import { freeze } from './utils/freeze';
var ResizeObserverSize = (function () {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        freeze(this);
    }
    return ResizeObserverSize;
}());
export { ResizeObserverSize };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js
// module id = 110
// module chunks = 0